<template>
  <div class="audit-dialog">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      @close="close"
      width="400px"
      center>
      <slot></slot>
      <div>
        <el-input type="textarea" rows="3" width="100%" v-model="reason" :placeholder="subTitle"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="fail">{{cancelText}}</el-button>
        <el-button type="primary" @click="success">{{confirmText}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'audit-dialog',
  components: {},
  props: ['title', 'subTitle', 'cancelText', 'confirmText'],
  props: {
    title: {
      type: String,
      default: '审核'
    },
    subTitle: {
      type: String,
      default: '如审核不通过，请输入审核失败原因'
    },
    cancelText: {
      type: String,
      default: '审核失败'
    },
    confirmText: {
      type: String,
      default: '审核成功'
    },
  },
  data() {
    return {
      dialogVisible: false,
      reason: ''
    }
  },
  mounted() {},
  methods: {
    close() {
      this.reason = ''
    },
    fail() {
      if (!this.reason) return this.$message.error('请输入失败原因')
      this.$emit('fail', this.reason)
      this.hideModal()
    },
    success() {
      this.$emit('success')
      this.hideModal()
    },
    showModal() {
      this.dialogVisible = true
    },
    hideModal() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.audit-dialog{
  /deep/ .el-textarea {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/AuditDialog.vue